<!-- <p>url = {{url3_5}}</p><p>legacyWebUi - {{legacyWebUI}}</p><p>listSpec = {{listSpec}}</p>   -->

<ng-template [ngIf]="legacyWebUI && url3_5">
  <p *ngIf="unsupportedPattern && !isProduction" style="font-weight: bold; color:red; height: 20px;text-align: center; position:absolute; width:100%">
    CURRENTLY UNSUPPORTED SOHO XI PATTERN DETECTED
  </p>
  <lm-html-url-doc
    [url]="url3_5"
    [showLoading]="false"
    (titleChanged)="onTitleChanged($event)">
  </lm-html-url-doc>
</ng-template>

<ng-container *ngIf="initialBuildComplete && !url3_5">
  <div *ngIf="routeReuseMode && isRouterOutletRootComponent && lmContextService.isDeveloper()" class="font-size-px-16 route-reuse-indicator">Route Reuse Active</div>
  <ng-container *ngIf="implementsCancellablePaging && showCancellableNotification">
    <lm-notification
            [isVisible] = "showCancellableNotification"
            [notificationType] = "'info'"
            [message] = "cancelablePagingMessage"
            [actionMessage] = "cancelablePagingActionMessage"
            (lmNotificationEvent) = "onLMNotificationEvent($event)">
    </lm-notification>
  </ng-container>

  <div soho-busyindicator *ngIf="bannerInRoute && isCardViewWithDetailSections" style="flex-direction: column"
    [text]="' '"
    [displayDelay]="20"
    [overlayOnly]="true"
    [timeToComplete]="this.uiLoadingIndicatorTimeout">
    <div *ngIf="isCubeView; then cubeView; else regularList"></div>
  </div>

  <div soho-busyindicator *ngIf="!bannerInRoute || (bannerInRoute && !isCardViewWithDetailSections)"
      [text]="' '"
      [displayDelay]="20"
      [overlayOnly]="true"
      [timeToComplete]="this.uiLoadingIndicatorTimeout"
      [class.search-form-on-left]="searchFormOnLeft">
    <div *ngIf="isCubeView; then cubeView; else regularList"></div>
  </div>

  <!-- CUBES -->
  <ng-template #cubeView>
    <div [ngClass]="standardCubeListClasses">
      <div class="lmc no-scroll" [ngClass]="cubeListContainerClasses">
          <ng-container *ngIf="bannerInRoute && isRouterOutletRootComponent">
            <soho-header #SohoHeader [hasTabs]="false" [hasToolbar]="false">
              <ng-container *ngTemplateOutlet="ToolbarMarkup"></ng-container>
            </soho-header>
          </ng-container>
          <ng-container *ngIf="hasSearchForm">
          <lm-form
              [ngClass]="{ 'hidden' : !((!displaySearchInDialog && showSearchForm) || !searchFormIsAlways), 'search-form-card-view-with-details': isCardViewWithDetailSections  }"
              [formUrlInfo]="searchFormUrlInfo"
              [formSpec]="searchFormSpec"
              [initDataView]="searchFormDataView"
              [formOptions]="searchFormOptions"
              [columnarText]="columnarSubTitle"
              [style.display]="showSearchForm || searchFormIsAlways ? 'block' : 'none'"
              (cubeSearchOpenLookupEvent)="onCubeSearchOpenLookup($event)"
              (searchButtonClicked)="onSearchClicked($event)"
              (clearSearchButtonClicked)="onClearSearchClicked($event)"
              (formDisplayed)="onSearchFormDisplayed()">
          </lm-form>
          <div #SearchFormPlaceholder></div>
          <lm-list-searchtags
              *ngIf="!showSearchForm && !searchFormIsAlways && hasSearchTags"
              [automationIdPrefix]="searchFormSpec.automationId"
              [searchTags]="searchTags"
              (searchTagRemoved)="onSearchTagRemoved($event)"
              (clearFilter)="onClearSearchTags()"
              (refineFilter)="onRefineFilter()"
          ></lm-list-searchtags>
        </ng-container>
        <lm-list-content
            attr.id="{{testVersion1 ? listSpec?.busListSpec?.id : null}}"
            [style.height]="this.lmContextService.inMingleWidget() ? 'calc(100% - 45px)' : '100%'"
            [listUrlInfo]="listUrlInfo"
            [listSpec]="listSpec"
            [disabled]="disabled"
            [fromDataView]="fromDataView"
            [displayType]="displayType"
            [chartName]="chartName"
            [filterCriteria]="filterCriteria"
            [columnfilterOperators]="columnfilterOperators"
            [filterListFilterCriteria]="filterListFilterCriteria?.filterCriteria"
            [hasFilterList]="hasFilterList"
            [sortOrder]="sortOrder"
            [selectRequestData]="selectRequestData"
            [showFilter]="showFilter"
            [listState]="listState"
            [listPersonalization]="listPersonalization"
            [isDashBoardContent]="isDashBoardContent"
        >
        </lm-list-content>
      </div>
      <ng-container [ngTemplateOutlet]="ListDetailContent"></ng-container>
    </div>
  </ng-template>

  <ng-template #regularList>
    <div *ngIf="searchFormOnLeft" [ngClass]="{'lm-search-form-on-left': true}" [style.display]="showSearchForm || searchFormIsAlways ? 'block' : 'none'">
      <ng-container *ngTemplateOutlet="SearchForm"></ng-container>
    </div>
    <div *ngIf="isCardViewWithDetailSections; then cardListDetails; else standardList"></div>
  </ng-template>

  <!--
    LIST WITH STANDARD DETAIL SECTIONS
    NOTE: DON'T need height 100% now that it's just for standard list and standard detail sections: [style.height]="'100%'"
  -->
  <ng-template #standardList>
    <div [ngClass]="standardListClasses" [class.detail-side]="showListDetailOnSide">
      <div class="lm-list-container lmc" [ngClass]="listContainerClasses" [class.no-scroll]="!showListDetailOnSide">
        <ng-container [ngTemplateOutlet]="ListMainContent"></ng-container>
      </div>
      <div [ngClass]="{'detail-content-side': showListDetailOnSide}">
        <ng-container [ngTemplateOutlet]="ListDetailContent"></ng-container>
      </div>
    </div>
  </ng-template>

  <!--
    CARD LIST WITH DETAIL SECTIONS ON THE SIDE
  -->
  <ng-template #cardListDetails>

    <ng-container *ngIf="bannerInRoute && isRouterOutletRootComponent">
      <soho-header #SohoHeader [hasTabs]="false" [hasToolbar]="false" style="min-height: 60px;" class="lm-header-card-list">
        <ng-container *ngTemplateOutlet="ToolbarMarkup; context: { setInHeader: true }"></ng-container>
      </soho-header>
    </ng-container>

    <lm-drawer
      [showDetails]="showDetails$ | async"
      [showDetailsOnSide]="showDetailsOnSide"
      [additionalClasses]="drawerAdditionalClasses">
      <lm-drawer-side class="lm-list-container lmc no-scroll sidebar" [collapsed]="drawerCollapse$ | async">
        <ng-container [ngTemplateOutlet]="ListMainContent"></ng-container>
      </lm-drawer-side>

      <lm-drawer-side-collapsed [collapsed]="drawerCollapse$ | async">
        <ng-container [ngTemplateOutlet]="CollapsedList"></ng-container>
      </lm-drawer-side-collapsed>

      <lm-drawer-content class="main">
        <ng-container [ngTemplateOutlet]="ListDetailContent"></ng-container>
      </lm-drawer-content>
    </lm-drawer>
  </ng-template>

  <ng-template #CollapsedList>
    <div class="collapsed-list-title" *ngIf="isAbovePhoneView$ | async">
      <h2 soho-tooltip title="{{listTitle}}">{{listTitle}}</h2>
      <!-- disable the more button for now -->
      <!-- <button id="{{ listSpec?.busListSpec?.id }}_collapsed_menu_button"
        soho-button="icon"
        icon="more"
        class="btn-actions"
        soho-context-menu
        menu="{{ listSpec?.busListSpec?.id }}_collapsed_menu"
        trigger="click"
        [beforeOpen]="onBeforeListToolbarMoreMenuOpen"
        (selected)="onContextMenuItemSelected($event)">
      </button> -->
      <span class="separator"></span>
      <h3 *ngIf="selectedDataView"
        soho-tooltip
        title="{{selectedDataView.representativeText}}">
        {{selectedDataView.representativeText}}
      </h3>
    </div>
    <button id="{{ listSpec?.busListSpec?.id }}_collapsed_button"
      soho-button="icon"
      icon="expand-app-tray"
      [ripple]="false"
      (click)="expandDrawerSide()">
    </button>
  </ng-template>

  <ng-template #ListMainContent>
    <div class="scrollable-flex" [style.height]="listContainerContentStyleHeight">
      <div [ngClass]="{'scrollable-flex-header': true, 'panel-header card-header': isFilterList, 'show-search-form' : showSearchForm}">
        <lm-list-selectiontags #ListSelectionTags
          *ngIf="allowMaintainingSelectedValues"
          [displaySelectionTags]="showMultiSelectTags"
          [automationIdPrefix]="screenAutomationId"
          [selectionTags]="selectionTags"
          (selectionTagRemoved)="onSelectionTagRemoved($event)"
        ></lm-list-selectiontags>
        <ng-container *ngIf="displayToolbar">
          <!--
          [searchField]="!isCardViewWithDetailSections ? toolbarSearchField : null"
          DON'T set search field if using the card with detail sections pattern. Another component
          manages the search field in this scenario
          -->

          <ng-container *ngIf="bannerInRoute && isRouterOutletRootComponent && !isCardViewWithDetailSections; else ToolbarMarkup">
            <soho-header #SohoHeader [hasTabs]="false" [hasToolbar]="false">
              <ng-container *ngTemplateOutlet="ToolbarMarkup"></ng-container>
            </soho-header>
            <ng-container *ngIf="toolbarAboveList && !isCardViewWithDetailSections">
              <ng-container *ngTemplateOutlet="ToolbarMarkup; context: { bannerInRouteListToolbar: true }"></ng-container>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="isFilterList">
            <h2 class="card-title" soho-tooltip [title]="listTitle">{{listTitle}}</h2>
            <button soho-button="btn"
              class="btn btn-close list-detail-list-close-button"
              [icon]="'close'"
              soho-tooltip
              [title]="'Hide Filter List'">
            </button>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="isDashBoardContentWithRecordCount">
          <header class="lm-list-header-record-count result-set-in-dashboard">{{mustacheText}}</header>
        </ng-container>

        <!-- Displays panel text -->
        <lm-form-panel-text
          *ngIf="listText"
          [panelText]="listText"
          [fromDataView]="fromDataView">
        </lm-form-panel-text>

        <ng-container *ngIf="searchFieldOnCardViewWithDetails">
          <div class="lm-listview-search">
            <!-- soho controls now strip style off of the soho-searchfield-wrapper, so in this case wrap in a div and apply the width to that -->
            <div [style.width]="hasKeywordIcons ? keywordSearchWidth : '100%'">
              <span soho-searchfield-wrapper attr.data-automation-id="lm-{{screenAutomationId}}-searchfield-wrapper">
                <input soho-searchfield
                    #SearchField
                    placeholder="{{searchPlaceholder}}"
                    attr.data-automation-id="lm-{{screenAutomationId}}-searchfield"
                    [(ngModel)]="listViewSearchFieldValue"
                    (keydown.enter)="onListViewSearchFieldEvent()"
                >
              </span>
            </div>
            <button *ngIf="hasScannableKeyword" (click)="onBarCodeClick()">
              <svg soho-icon [icon]="'barcode'"></svg>
            </button>
            <button *ngIf="hasSearchForm && !searchFormIsAlways"
                (click)="onFilterButtonClicked()"
                title="Filter Search"
                attr.data-automation-id="lm-{{screenAutomationId}}-searchfield-filter-button"
                attr.aria-label="{{'FilterSearch' | translate}}"
                attr.aria-expanded="{{showSearchForm || searchFormIsAlways ? 'true' : 'false'}}"
            >
              <svg soho-icon [icon]="'filter'"></svg>
            </button>
          </div>
        </ng-container>

        <ng-container *ngIf="!searchFormOnLeft">
          <ng-container *ngTemplateOutlet="SearchForm"></ng-container>
        </ng-container>
        <ng-container *ngTemplateOutlet="listTags"></ng-container>
      </div>

      <div class="scrollable-flex-content" [ngClass]="detailFieldsClass">
        <lm-list-content
            attr.id="{{testVersion1 ? listSpec?.busListSpec?.id : null}}"
            class="main-list"
            [listUrlInfo]="listUrlInfo"
            [listSpec]="listSpec"
            [fromDataView]="fromDataView"
            [displayType]="displayType"
            [chartName]="chartName"
            [filterCriteria]="filterCriteria"
            [columnfilterOperators]="columnfilterOperators"
            [filterListFilterCriteria]="filterListFilterCriteria?.filterCriteria"
            [hasFilterList]="hasFilterList"
            [implementsDragAndDrop]="implementsDragAndDrop"
            [sortOrder]="sortOrder"
            [selectRequestData]="selectRequestData"
            [showFilter]="showFilter"
            [listState]="listState"
            [listPersonalization]="listPersonalization"
            [isDashBoardContent]="isDashBoardContent"
            [disabled]="disabled"
            [implementsManualLoad]="implementsManualLoad"
            [manualLoadInfo]="manualLoadInfo"
            [multiSelectedValues]="multiSelectedValues"
            [inSelectListEditMode]="inSelectListEditMode">
        </lm-list-content>

        <div id="{{contextScanMenuId}}" *ngIf="showScanOptionsContextMenu" class="popupmenu-wrapper" role="application" aria-hidden="true">
          <ul soho-popupmenu
            attr.id="{{contextScanMenuId}}"
            menu="{{contextScanMenuId}}"
            trigger='immediate'
            [useCoordsForClick]="true"
            [attachToBody]="true"
            [removeOnDestroy]="true"
            [eventObj]="contextScanMenuEvent"
            (selected)="contextScanMenuClicked($event)"
            (close)="onCloseContextScanMenu($event)"
          >
            <li soho-popupmenu-item>
              <a id="ScanEvent" href="javascript:void(0);" role="menuitem" tabindex="-1">{{ 'Scan' | translate }}</a>
            </li>

            <li soho-popupmenu-item>
              <a id="SelectEvent" href="javascript:void(0);" role="menuitem" tabindex="-1">{{ 'Select' | translate }}</a>
            </li>
          </ul>
        </div>

        <ng-container *ngIf="hasDetailFields && !hasDetailSections && !implementsOrgChartView && detailFieldsFormModel">
          <lm-form-content-form #detailFieldsFormComponent
            class="detail-fields"
            [specFields]="detailFieldsSpecFields"
            [formSpec]="detailFieldsFormSpec"
            [layout]="detailFieldsFormLayout"
            [model]="detailFieldsFormModel"
              (fieldEvent)="onFieldEvent($event)"
          ></lm-form-content-form>
        </ng-container>

        <ng-container *ngIf="showChangeValuesOnRight">
          <lm-list-audit-compare-panel
            id='compare-detail-view'
            class="compare-panel"
            [ngStyle]="{'visibility': dashboardVisibility }">
          </lm-list-audit-compare-panel>
        </ng-container>
      </div>
    </div>
  </ng-template>

  <ng-template #ToolbarMarkup let-setInHeader="setInHeader" let-bannerInRouteListToolbar="bannerInRouteListToolbar">
    <!--  <ng-container *ngIf="hideTitleBar">   -->
    <!--  <p>setInHeader: {{setInHeader}}, doNotShowAsHeader: {{doNotShowAsHeader}}</p>  -->
    <lm-toolbar
        *ngIf="!isFilterList && !usedInCartView"
        [toolbarIdPrefix]="screenId"
        [automationId]="screenAutomationId"
        [inHeader]="bannerInRouteListToolbar ? false : setInHeader ? true : isRouterOutletRootComponent && bannerInRoute && !isCardViewWithDetailSections"
        [sectionTitle]="isCardViewWithDetailSections ? listTitle : bannerInRouteListToolbar ? '' : !isRouterOutletRootComponent || (isRouterOutletRootComponent && (!toolbarAboveList || bannerInRoute)) ? listTitle : ''"
        [searchField]="!isCardViewWithDetailSections ? toolbarSearchField : null"
        [buttons]="isCubeView && bannerInRoute ? null : toolbarButtons | async"
        [disabled]="disabled"
        [hideToolbarTitles]="listSpec.showAsMingleWidget"
        [hideOverflowMenuButton]="listSpec.showAsMingleWidget"
        [showListDetailBackButton]="hasFilterList"
        [moreMenuSettings]="toolbarMoreMenuSettings"
        [mustacheText]="mustacheText"

        [class.lm-banner-in-route-list-toolbar]="bannerInRouteListToolbar"

        [class.panel-header]="isCardViewWithDetailSections"
        [class.showSearchForm]="showSearchForm"
        [class.card-group-action]="this.listSpec.showAsMingleWidget"
        [style.padding-right.px]="3"

        (appMenuTriggerEvent)="onAppMenuTriggerEvent($event)"
        (toolbarButtonEvent)="onToolbarButtonEvent($event)"
        (toolbarSearchEvent)="onToolbarSearchEvent()"
        (toolbarSearchClearedEvent)="onToolbarSearchClearedEvent()">
    </lm-toolbar>
    <!--  </ng-container>  -->
  </ng-template>

  <ng-template #ListDetailContent>
    <lm-dashboard-view
      *ngIf="isDetailDashboardView && selectedDataView"
      id='detail-dashboard-view'
      [ngClass]="{ 'lm-list-detail bottom' : !isCardViewWithDetailSections, 'main': isCardViewWithDetailSections, 'scrollable': true}"
      [ngStyle]="{ 'visibility': dashboardVisibility, height: '100%'}"
      [columns]="listSpec.busListSpec.dashboardColumns"
      [dashboardPanels]="detailSectionPanels"
      [fromDataView]="selectedDataView"
      (uiLinkEvent)="onUILinkEvent($event)"
      (contentModified)="onContentModified($event)"
      (dashboardContentDisplayed)="onPanelContentDisplayed($event)"
      (sendContextMessageEvent)="onSendContextMessageEvent($event)">
    </lm-dashboard-view>

    <lm-twelve-column-grid
      *ngIf="isDetailTwelveColumnGridView && selectedDataView"
      id='detail-twelve-column-grid'
      [ngClass]="{ 'lm-list-detail bottom' : !isCardViewWithDetailSections, 'main': isCardViewWithDetailSections, 'scrollable': true}"
      [ngStyle]="{ 'visibility': dashboardVisibility, height: '100%'}"
      [dashboardPanels]="detailSectionPanels"
      [fromDataView]="selectedDataView"
      (uiLinkEvent)="onUILinkEvent($event)"
      (contentModified)="onContentModified($event)"
      (dashboardContentDisplayed)="onPanelContentDisplayed($event)"
      (sendContextMessageEvent)="onSendContextMessageEvent($event)">
    </lm-twelve-column-grid>

    <lm-detail-sections
        *ngIf="isDetailSectionsView && selectedDataView"
        [hideTabs]="hideDetailSectionTabs"
        [showSinglePanelTab]="listSpec.busListSpec.showSinglePanelTab"
        [ngClass]="{ 'lm-list-detail bottom' : !isCardViewWithDetailSections, 'main': isCardViewWithDetailSections }"
        [ngStyle]="{ 'visibility': dashboardVisibility }"
        [listState]="listState"
        [detailSectionIdPrefix]="listSpec.busListSpec.id"
        [detailSectionAutomationIdPrefix]="listSpec.busListSpec.automationId"
        [detailSectionPanels]="detailSectionPanels"
        [isCardListDetailSections]="isCardViewWithDetailSections"
        [fromDataView]="selectedDataView"
        (uiLinkEvent)="onUILinkEvent($event)"
        (contentModified)="onContentModified($event)"
        (panelContentDisplayed)="onPanelContentDisplayed($event)"
        (sendContextMessageEvent)="onSendContextMessageEvent($event)"
        (panelDataUpdated)="onPanelDataUpdated($event)"
        (drillAroundEvent)="onDrillAroundEvent($event)"
        (cubeDetailSectionPVPeriodEvent)="onCubeDetailSectionPVPeriodEvent($event)">
    </lm-detail-sections>
  </ng-template>

  <!--
    id="{{contextMenuId}}" - Need a dynamic id due to datagrid needing to lookup the menu ul by it's id for a context menu.
  -->

  <div *ngIf="displayContextMenu" class="popupmenu-wrapper" role="application" aria-hidden="true">
    <ul soho-popupmenu
      attr.id="{{contextMenuId}}"
      menu="{{contextMenuId}}"
      [ngClass]="{'is-context-menu': displayContextMenu, 'has-checked-item': inSelectListEditMode}"
      trigger='immediate'
      [attachToBody]="true"
      [attributes]=contextMenuAttributes
      [removeOnDestroy]="true"
      [eventObj]="contextMenuEvent"
      (selected)="onContextMenuItemSelected($event)"
      (close)="onCloseContextMenu($event)"
      [beforeOpen]="onBeforeContextMenuOpen"
      (keydown)="onKeyDown($event)"
    >
    </ul>
  </div>
</ng-container>

<ng-template #SearchForm>
  <ng-container *ngIf="hasSearchForm">
    <lm-form
            [ngClass]="{ 'hidden' : !((!displaySearchInDialog && showSearchForm) || !searchFormIsAlways), 'search-form-card-view-with-details': isCardViewWithDetailSections  }"
            [formUrlInfo]="searchFormUrlInfo"
            [formSpec]="searchFormSpec"
            [initDataView]="searchFormDataView"
            [formOptions]="searchFormOptions"
            [columnarText]="columnarSubTitle"
            [style.display]="showSearchForm || searchFormIsAlways ? 'block' : 'none'"
            (fieldEvent)="onFieldEvent($event)"
            (searchButtonClicked)="onSearchClicked($event)"
            (clearSearchButtonClicked)="onClearSearchClicked($event)"
            (formDisplayed)="onSearchFormDisplayed()">
    </lm-form>
    <div #SearchFormPlaceholder></div>
  </ng-container>
</ng-template>

<ng-template #listTags>
  <lm-list-searchtags
          *ngIf="hasSearchForm && !showSearchForm && !searchFormIsAlways && hasSearchTags"
          [idPrefix]="searchFormSpec?.busFormSpec?.name"
          [automationIdPrefix]="searchFormSpec.automationId"
          [searchTags]="searchTags"
          (searchTagRemoved)="onSearchTagRemoved($event)"
          (clearFilter)="onClearSearchTags()"
          (refineFilter)="onRefineFilter()"
  ></lm-list-searchtags>
</ng-template>

<div #modalPlaceholder id="modalPlaceholder"></div>

<!-- Placeholder required by popupmenu to be used for the collapsed list -->
<ul soho-popupmenu id="{{ listSpec?.busListSpec?.id }}_collapsed_menu"></ul>

<ng-container *ngIf="listSpec?.busListSpec?.attachmentListInfo">
  <ng-container *ngIf="listSpec.busListSpec.attachmentListInfo.hasCreateAction">
    <input #attachmentFileInput
        attr.data-automation-id="lm-{{screenAutomationId}}-file-input"
        type="file"
        multiple="true"
        id="{{ listSpec?.busListSpec?.id }}_fileInput"
        style="display:none;"
        (change)="attachmentListFileInputChange()"
    />
  </ng-container>
  <ng-container *ngIf="!listSpec.busListSpec.attachmentListInfo.disableDownload">
    <a #standardDownloadAction id="{{ listSpec?.busListSpec?.id }}_downloadAnchor" style="display:none;"></a>
  </ng-container>
</ng-container>
